<template>
    <div>
        <div>
            <img style="object-fit: cover;width: 100%;height: 250px;" :src="image" alt=""/>
            <div style="text-align: center;">
                <p
                    style="
                    color: #545da7;
                    font-size: 16px;
                    height: 21px;
                    display: -webkit-box;
                    -webkit-line-clamp: 1;
                    -webkit-box-orient: vertical;
                    max-width:100%;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    "
                >
                    {{ item.name }}

                </p>
            </div>
        </div>

    </div>

</template>
<script>
export default {
    props: {
        item: {
            type: Object,
            required: true
        }
    },
    computed:{

        image(){
            var src = this.item.img
                            ?this.item.img.image
                            :'https://kubalubra.is/wp-content/uploads/2017/11/default-thumbnail.jpg'
            return src;
        }

    },
}
</script>
